import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import UserHelper from '../helpers/user-helper';

@Injectable({
  providedIn: 'root',
})
export class AdminAuthGuardService implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.isAuthenticated()
      ? this.authService
          .getCurrentUser()
          .toPromise()
          .then(
            (res) => {
              if (UserHelper.isAdmin(res.body)) {
                return true;
              } else if (UserHelper.isIPPlacer(res.body)) {
                this.router.navigateByUrl('/ip-installateur');
              } else if (UserHelper.isPlacer(res.body)) {
                this.router.navigateByUrl('/installateur');
              } else if (UserHelper.isClient(res.body)) {
                this.router.navigateByUrl('/client-corner/lopende');
              } else {
                this.router.navigateByUrl('/no-access');
              }
              return false;
            },
            (err) => {
              console.error(err);
              return false;
            }
          )
      : this.router.navigateByUrl('/login');
  }
}
